import { getLocaleWordContent } from '@/utils/language.util';
import React from 'react';
export default function Tab({ tab, setTab }) {
    const data = [getLocaleWordContent('입금'), getLocaleWordContent('출금')];
    return (
        <div className="tab">
            <ul className="tab_history">
                {data.map((it, index) => (
                    <li key={index} className={tab === index ? 'atc' : null} onClick={() => setTab(index)}>
                        {it}
                    </li>
                ))}
            </ul>
        </div>
    );
}
